import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SubSink } from 'subsink2';
import { ViewColumn } from '../../../../view-column';
import { ViewColumnComponent } from '../../../../view-column.component';
import { PermissionSetPagesService } from '../../../../modules/permission/services/perm-set-pages.service';
import { PermissionFacade } from '../../../../modules/permission/facades/permission.facade';
import { containerTemplate } from '../../../../modules/layout/container';
import { containerAnim } from '../../../../modules/layout/animations/animations';
import { FirstColumnDirective } from '../../../../utilities/first-column.directive';
import { SecondColumnDirective } from '../../../../utilities/second-column.directive';
import { ActivatedRoute } from '@angular/router';

@Component({
  template: containerTemplate,
  animations: containerAnim,
  providers: [PermissionSetPagesService]

})
export class PermissionSetContainerComponent implements OnInit, OnDestroy {

  // Directives for the first and second drawers
  @ViewChild(FirstColumnDirective, {static: true}) firstColumnHost: FirstColumnDirective;
  @ViewChild(SecondColumnDirective, {static: true}) secondColumnHost: SecondColumnDirective;

  leftDrawer: ViewColumn[];
  rightDrawer: ViewColumn[];

  breadCrumbs: ViewColumn[];

  firstCol: ViewColumn;
  secondCol: ViewColumn;

  mobileView = window.matchMedia('(max-width: 768px)');

  targetServices;

  private subSink = new SubSink;

  constructor(
    private viewColFacade: PermissionFacade,
    private componentFactoryResolver: ComponentFactoryResolver,
    private pagesService: PermissionSetPagesService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.subSink.sink = this.route.data.subscribe(a => this.targetServices = a.targetServices);
    // Cache the Applet Module view
    this.subSink.sink = this.viewColFacade.permissionSetCache$.subscribe( a =>
        a ? this.viewColFacade.setViewColState(a) : this.viewColFacade.setViewColState(this.pagesService.pages)
    );

    // Configure the view size for when we choose to see either one or two columns
    this.mobileView.matches ? this.viewColFacade.toggleColumn(true) : this.viewColFacade.toggleColumn(false);
    this.mobileView.addEventListener('change', _ => {
      this.mobileView.matches ? this.viewColFacade.toggleColumn(true) : this.viewColFacade.toggleColumn(false);
    });

    // Configure the views
    this.subSink.sink = this.viewColFacade.firstCol$.subscribe( resolve => {
      this.firstCol = resolve;
      this.loadComponent(resolve, this.firstColumnHost);
    });
    this.subSink.sink = this.viewColFacade.secondCol$.subscribe( resolve => {
      this.secondCol = resolve;
      this.loadComponent(resolve, this.secondColumnHost);
    });

    this.subSink.sink = this.viewColFacade.leftDrawer$.subscribe( resolve => this.leftDrawer = resolve );
    this.subSink.sink = this.viewColFacade.rightDrawer$.subscribe( resolve => this.rightDrawer = resolve );

    this.subSink.sink = this.viewColFacade.breadCrumbs$.subscribe( resolve => this.breadCrumbs = resolve );

  }

  loadComponent( comp: ViewColumn, host: FirstColumnDirective | SecondColumnDirective ) {
    const viewContainerRef = host.viewContainerRef;
    viewContainerRef.clear();
    if (!comp) {
      return;
    }
    const compFactory  = this.componentFactoryResolver.resolveComponentFactory(comp.component);
    const compRef = viewContainerRef.createComponent<ViewColumnComponent>(compFactory);
    compRef.instance.targetServices = this.targetServices;
  }

  goBackIndex(i: number) {
    this.viewColFacade.goBackIndex(i);
  }

  goForwardIndex(i: number) {
    this.viewColFacade.goForwardIndex(i);
  }

  goToIndex(i: number) {
    this.viewColFacade.goToIndex(i);
  }

  ngOnDestroy() {
    this.viewColFacade.savePermissionSetState();
    this.subSink.unsubscribe();
  }

}
